// Mirrors SENTRY_ENVIRONMENT on the backend; one frontend image serves every host.
export function sentryEnvironment(hostname: string): string {
  if (hostname === "dev.quotiss.com") {
    return "dev";
  }
  if (hostname === "suus.quotiss.com") {
    return "suus";
  }
  if (hostname.endsWith(".review.quotiss.com")) {
    return "review";
  }
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "local";
  }
  return "prod";
}
